import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { notificationStore, useTranslation } from '@pascal/pascal-core';
import { freeBetStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { doBetStore } from '../../store/doBetStore';
import { turboGameService } from '../../services/TurboGameService';
import { gameStore } from '../../store/gameStore';
import { winningAmountStore } from '../../store/winningAmountStore';
import { betResponseCodeByName } from '../../enums/betResponseCode';
import { soundService, soundTypes } from '../../services/SoundService';

const BetActionPanel = observer(() => {
  const {
    betsModels,
    isDefaultAmount,
    reBet,
    reBetAmount,
    setBetsModel,
    setDouble,
    setUndoBet,
    clearDefaultBets,
  } = doBetStore;
  const { isBetsClosed } = gameStore;
  const { activeFreeBet } = freeBetStore;
  const { setLastWin } = winningAmountStore;
  const { balance } = userInfoStore;
  const t = useTranslation();

  const handleReBetOrDoubleBet = useCallback(() => {
    setLastWin(null);
    if (reBet && !betsModels.length && !isBetsClosed) {
      if (reBetAmount > balance) {
        notificationStore.setNotificationType(betResponseCodeByName.NotEnoughBalance);
        setTimeout(() => notificationStore.setNotificationType(null), 1000);
        return;
      }
      setBetsModel({ betModel: reBet });
      soundService.play(soundTypes.chip);
    } else {
      setDouble();
    }
  }, [reBet, betsModels, isBetsClosed, balance, reBetAmount, setBetsModel, setDouble, setLastWin]);

  return (
    <div className='tb-control-panel'>
      <div className='tb-deal-btn-group'>
        {betsModels.length ? (
          <div
            className='tb-action-btn-block'
            onClick={() => (isDefaultAmount ? clearDefaultBets() : setUndoBet())}
          >
            <button type='button' className='tb-action-btn'>
              <i className={`icon-${isDefaultAmount ? 'undo-clear' : 'undo-clear'}`} />
              <span>undo</span>
            </button>
          </div>
        ) : null}
        <div className={`tb-deal-btn-block ${!betsModels.length ? 'disabled' : ''}`}>
          <button
            type='button'
            className='tb-deal-button'
            onClick={() => turboGameService.sendBet()}
            disabled={!betsModels.length}
          >
            <span>{t('DEAL')}</span>
          </button>
        </div>
        {(betsModels.length || (!betsModels.length && reBet)) && (
          <div
            className={`tb-action-btn-block ${
              betsModels.length && activeFreeBet.id ? 'disabled' : ''
            }`}
          >
            <button type='button' onClick={handleReBetOrDoubleBet} className='tb-action-btn'>
              <i className={`icon-${betsModels.length ? 'double' : 'new-rebet'}`} />
              <span>double</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
});
export default BetActionPanel;
